export default "__VITE_ASSET__7yauiUH0__"